const CANONICAL_CORNER = {
  n: "n",
  s: "s",
  e: "e",
  w: "w",
  nw: "nw",
  ne: "ne",
  sw: "sw",
  se: "se",
  top: "n",
  bottom: "s",
  left: "w",
  right: "e",
  topLeft: "nw",
  topRight: "ne",
  bottomLeft: "sw",
  bottomRight: "se",
};

const ASPECT_LOCK_CORNERS = new Set(["nw", "ne", "sw", "se"]);

export const resizePixelBoxFromHandle = ({
  origin,
  corner,
  startPoint,
  point,
  minSize = 8,
  aspectRatio,
}) => {
  const handle = CANONICAL_CORNER[corner] || corner;
  const originRight = origin.x + origin.width;
  const originBottom = origin.y + origin.height;
  const originW = Math.max(origin.width, minSize);
  const lockedAspect = Number(aspectRatio);
  const originH =
    lockedAspect > 0
      ? originW / lockedAspect
      : Math.max(origin.height, minSize);

  if (ASPECT_LOCK_CORNERS.has(handle)) {
    const fromWest = handle.includes("w");
    const fromNorth = handle.includes("n");
    const anchorX = fromWest ? originRight : origin.x;
    const anchorY = fromNorth ? originBottom : origin.y;
    const denom = originW * originW + originH * originH;
    const signedDelta = ({ x, y }) => {
      const signedX = fromWest ? anchorX - x : x - anchorX;
      const signedY = fromNorth ? anchorY - y : y - anchorY;
      return denom > 0 ? (signedX * originW + signedY * originH) / denom : 1;
    };
    const startScale = signedDelta(startPoint);
    const cursorScale = signedDelta(point);
    const minScale = Math.max(minSize / originW, minSize / originH);
    const scale = Math.max(
      minScale,
      startScale > 0 ? cursorScale / startScale : cursorScale
    );
    const nextW = originW * scale;
    const nextH = originH * scale;
    return {
      x: fromWest ? originRight - nextW : origin.x,
      y: fromNorth ? originBottom - nextH : origin.y,
      width: nextW,
      height: nextH,
    };
  }

  const dx = point.x - startPoint.x;
  const dy = point.y - startPoint.y;
  let x = origin.x;
  let y = origin.y;
  let width = origin.width;
  let height = origin.height;

  if (handle.includes("w")) {
    x = Math.min(origin.x + dx, originRight - minSize);
    width = originRight - x;
  } else if (handle.includes("e")) {
    width = Math.max(minSize, origin.width + dx);
  }

  if (handle.includes("n")) {
    y = Math.min(origin.y + dy, originBottom - minSize);
    height = originBottom - y;
  } else if (handle.includes("s")) {
    height = Math.max(minSize, origin.height + dy);
  }

  return { x, y, width, height };
};
